import { DEPOSIT_TO_PROVIDERS, DepositToProvider } from '@vy/types';
import { withDefault } from '@vy/utils';

const depositToProviderMap: Record<DepositToProvider, string> = {
  [DEPOSIT_TO_PROVIDERS.UndepositedFunds]: 'Undeposited Funds',
  [DEPOSIT_TO_PROVIDERS.BankAccounts]: 'Bank Accounts',
  [DEPOSIT_TO_PROVIDERS.Other]: 'Other',
};

export function getDepositToProviderNameToDisplay(depositToProvider: DepositToProvider | string) {
  return withDefault(depositToProviderMap[depositToProvider as DepositToProvider], depositToProvider);
}
